var map = {
	"./BySN.jpg": "5eb6",
	"./default.png": "113c",
	"./excel.png": "444c",
	"./logo.png": "cf05",
	"./logo.svg": "9b19",
	"./pdf.png": "9f06",
	"./rar.png": "60b6",
	"./texto.png": "d13a",
	"./word.png": "ccfd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";